import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai"; // Import eye icons
import "../styles/Login.css";
import Logo from "../assets/images/TCUK-Logo.png";
import HeaderLogo from "../components/HeaderLogo.jsx";
import { API_URL } from "../constant";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      const response = await fetch(`${API_URL}/superadmin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });

      const data = await response.json();

      console.log("Login API Response:", {
        status: response.status,
        data: data,
        requires_otp: data.requires_otp,
        user_id: data.user_id,
      });

      if (data.requires_otp === true && data.user_id) {
        console.log("OTP required, navigating to 2FA page");
        localStorage.setItem("superadmin_user_id", data.user_id);
        localStorage.setItem("superadmin_email", email);
        localStorage.removeItem("auth_token");
        navigate("/2fa");
        return;
      }

      if (response.ok && data.access_token && data.requires_otp === false) {
        localStorage.setItem("auth_token", data.access_token);
        navigate("/dashboard");
        return;
      }

      if (data.errors) {
        const validationErrors = {};
        Object.keys(data.errors).forEach((key) => {
          validationErrors[key] = data.errors[key][0];
        });
        setErrors(validationErrors);
      } else if (data.message) {
        switch (data.message) {
          case "Unauthorized access":
            setErrors({ general: "Invalid email or password" });
            break;
          case "Username or Password incorrect":
            setErrors({ general: "Invalid email or password" });
            break;
          case "Email not verified":
            setErrors({
              general: "Email not verified. Please verify your email first.",
            });
            break;
          default:
            setErrors({ general: data.message });
        }
      } else {
        setErrors({ general: "Login failed. Please try again." });
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrors({
        general: "Network error. Please check your connection and try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <HeaderLogo />

      <div className="login-card">
        <div className="login-logo">
          <img src={Logo} alt="login page" />
        </div>
        <h2 className="login-heading">Welcome Back!</h2>

        <p className="general-error">{errors.general || " "}</p>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-wrapper">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (errors.email) setErrors({ ...errors, email: "" });
              }}
              disabled={isLoading}
              className={errors.email ? "error-input" : ""}
             maxLength={255} />
            <p className="error">{errors.email || " "}</p>
          </div>

          <div className="input-wrapper">
            <label>Password</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errors.password) setErrors({ ...errors, password: "" });
                }}
                disabled={isLoading}
                className={`password-input ${errors.password ? "error-input" : ""}`}
                style={{ width: "100%", paddingRight: "40px" }}
               maxLength={255} />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#666",
                  padding: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  <AiFillEye size={20} />
                ) : (
                  
                  <AiFillEyeInvisible size={20} />
                )}
              </span>
            </div>
            <p className="error">{errors.password || " "}</p>
          </div>

          <div
            className="forgot-password"
            onClick={() => !isLoading && navigate("/forgot-password")}
          >
            Forgot password?
          </div>

          <button
            type="submit"
            className={`login-btn ${isLoading ? "loading" : ""}`}
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
